export interface Alliance {
  slug: string;
  country: string;
  percentage: number;
  startMs: number;
  endMs: number;
  campaign: string;
  appDownloadUrl: string;
  detailKey: string;
}

export const APP_DOWNLOAD_FROM_SMART_PRICING_URL = 'https://market.agendapro.com/app-ec-smartpricing';

// Same order as the rows: newest first.
export const ALLIANCES: readonly Alliance[] = [
  {
    slug: 'cmr-falabella',
    country: 'cl',
    percentage: 40,
    startMs: Date.parse('2026-10-01T00:00:00-03:00'),
    endMs: Date.parse('2026-12-31T23:59:59-03:00'),
    campaign: 'cmr_falabella',
    appDownloadUrl: 'https://market.agendapro.com/app-ec-cmr-falabella',
    detailKey: 'APP_OFFERS.CMR_FALABELLA_DETAIL',
  },
  {
    slug: 'bci-mach',
    country: 'cl',
    percentage: 40,
    startMs: Date.parse('2026-09-20T11:00:00-03:00'),
    endMs: Date.parse('2026-12-31T23:59:59-03:00'),
    campaign: 'bci_mach',
    appDownloadUrl: 'https://market.agendapro.com/app-ec-bci-mach',
    detailKey: 'APP_OFFERS.BCI_MACH_DETAIL',
  },
  {
    slug: 'cencosud-scotiabank',
    country: 'cl',
    percentage: 40,
    startMs: Date.parse('2026-08-01T13:00:00-04:00'),
    endMs: Date.parse('2026-12-31T23:59:59-03:00'),
    campaign: 'cencosud_scotiabank',
    appDownloadUrl: 'https://market.agendapro.com/app-ec-cencosud-scotiabank',
    detailKey: 'APP_OFFERS.CENCOSUD_DETAIL',
  },
];

export const alliancesInWindow = (countryCode: string, now: number = Date.now()): Alliance[] => {
  const country = countryCode.toLowerCase();

  return ALLIANCES.filter(
    (alliance) => alliance.country === country && now >= alliance.startMs && now <= alliance.endMs,
  );
};
